import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  background-color: ${constants.CORE_PRIMARY_2};
`

const GridContainer = styled.div<{ width?: number | null }>`
  width: calc(100% - ${props => props.width}px);
  height: 100%;
`

export const GridDetailLayout = ({
  children,
  gridStart,
  gridContainerRef
}: {
  children: React.ReactNode
  gridStart?: number
  gridContainerRef?: React.Ref<HTMLDivElement>
}) => {
  return (
    <Container>
      <GridContainer ref={gridContainerRef} width={gridStart}>
        {children}
      </GridContainer>
    </Container>
  )
}
